// Local (device-only) mock persistence. Nothing here is sent anywhere.
//
// Keys that hold restaurant-specific state are scoped by organization + branch
// so carts, orders, loyalty, sessions and ratings never collide when the same
// browser visits several FudiTap restaurants/branches:
//
//   fuditap_<name>:<organizationId>:<branchId>
//
// This is a collision-avoidance convention for the prototype — NOT tenancy or
// security. Real isolation must be enforced by the FudiTap backend.
import { restaurantConfig } from "@/config/restaurantConfig";

export function scopedKey(name, { orgId, branchId } = {}) {
  const org = orgId || restaurantConfig.id;
  const branch = branchId === null ? "*" : branchId || restaurantConfig.branch.id;
  return `fuditap_${name}:${org}:${branch}`;
}

export function readJSON(key, fallback) {
  try {
    const raw = window.localStorage.getItem(key);
    return raw == null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}

// Returns true when the value was persisted, false when storage failed.
export function writeJSON(key, value) {
  try {
    if (value === undefined || value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    // Storage full / blocked (private mode): the app keeps working in memory.
    return false;
  }
}

export function makeId(prefix) {
  const rand = Math.random().toString(36).slice(2, 8);
  return `${prefix}_${Date.now().toString(36)}${rand}`;
}
